import React from 'react'
import { Ability } from '@casl/ability'
import AbilityContext from '@components/blocks/Acl/Context'

export const withAcl =
  <P extends object>(Component: React.ComponentType<P>) =>
  (props: Omit<P, 'ability'>) => {
    return (
      <AbilityContext.Consumer>
        {(ability?: Ability) => <Component {...(props as P)} ability={ability} />}
      </AbilityContext.Consumer>
    )
  }
